import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'downward-arrow-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '30px',
    },
    'downward-arrow--client-selector': {
      width: '250px',
    },
    'downward-arrow--input': {
      width: '80%',
      marginBottom: '20px',
    },
    'fading-container': {
      animation: 'fadeIn ease 2s',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    },
    'downward-arrow--buttons-container': {
      display: 'flex',
      maxWidth: '250px',
      width: '200px',
      justifyContent: 'space-between',
    },
    'downward-arrow--image-title': {
      margin: '20px 0',
    },
    'downward-arrow--title': {
      marginBottom: '20px',
      textAlign: 'center',
    },
    'downward-arrow--tooltip': {
      minWidth: '50%',
    },
    'downward-arrows--thoughts-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '25px',
    },
    'downward-arrow--question-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '20px',
    },
    'downward-arrows--question-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    'downward-arrows--arrow-icon': {
      marginTop: '20px',
    },
  };
});
export default useStyles;
